import { useTranslation } from 'react-i18next';
import { CardHeader } from '@/components/base/Card';
import { domainProgress } from '@/mocks/dashboard';

export default function ProgressChart() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 rounded-xl border border-background-200 p-5">
      <CardHeader
        title={t('dashboard.multiDomainProgress')}
        subtitle={t('dashboard.progressSubtitle')}
        icon="ri-bar-chart-2-line"
        iconBg="bg-accent-100"
      />

      <div className="space-y-4">
        {domainProgress.map((d) => (
          <div key={d.domain} className="group">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <span className={`w-2.5 h-2.5 rounded-full ${d.color}`} />
                <span className="text-sm font-label font-medium text-foreground-800">{d.domain}</span>
              </div>
              <div className="flex items-center gap-3 text-xs font-label">
                <span className={`font-700 ${d.textColor}`}>{d.currentScore}%</span>
                <span className="text-foreground-400">{t('dashboard.baseline')}: {d.baselineScore}%</span>
                <span className={`font-medium ${d.textColor}`}>{d.avgChange} {t('dashboard.pts')}</span>
              </div>
            </div>

            {/* Dual bar */}
            <div className="relative h-6 bg-background-200 rounded-md overflow-hidden">
              <div
                className="absolute top-0 left-0 h-full bg-background-300 rounded-md transition-all duration-500"
                style={{ width: `${d.baselineScore}%` }}
              />
              <div
                className={`absolute top-0 left-0 h-full rounded-md transition-all duration-700 ease-out group-hover:brightness-110 ${d.color}`}
                style={{ width: `${d.currentScore}%` }}
              />
              <div
                className="absolute top-0 h-full w-0.5 bg-foreground-300/60 z-10"
                style={{ left: '80%' }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Legend */}
      <div className="flex items-center gap-6 mt-5 pt-4 border-t border-background-200">
        <div className="flex items-center gap-2 text-xs text-foreground-500 font-label">
          <div className="w-3 h-3 rounded-sm bg-background-300" />
          {t('dashboard.baseline')}
        </div>
        <div className="flex items-center gap-2 text-xs text-foreground-500 font-label">
          <div className="w-3 h-3 rounded-sm bg-accent-500" />
          {t('dashboard.current')}
        </div>
        <div className="flex items-center gap-2 text-xs text-foreground-500 font-label">
          <div className="w-0.5 h-3 bg-foreground-300/60" />
          {t('dashboard.goal80')}
        </div>
      </div>
    </div>
  );
}